import { useAppDispatch } from "../hooks";
import { ICategory } from "../interfaces/category.interface";
import { updateCategory } from "../services/firestore.service";
import { dismiss } from "../slices/dialogsSlice";

interface EditCategoryDialogProps {
    updateCategories: () => void;
    category: ICategory;
    projectId: string;
    dialogId: number;
}

const EditCategoryDialog = ({
    updateCategories,
    category,
    projectId,
    dialogId,
}: EditCategoryDialogProps): React.JSX.Element => {
    const dispatch = useAppDispatch();

    const close = () => {
        dispatch(dismiss(dialogId));
    };

    const saveCategory = (e: any) => {
        e.preventDefault();

        let data = new FormData(e.target);

        let newCategory: ICategory = {
            id: category.id,
            title: data.get("title").toString(),
            description: data.get("description").toString(),
            periods: category.periods,
            hidden: category.hidden ?? false,
        };

        updateCategory(projectId, newCategory).then(() => {
            updateCategories();
            close();
        });
    };

    return (
        <>
            <form onSubmit={saveCategory}>
                <h1>Edit Category</h1>
                <input placeholder="Title" name="title" defaultValue={category.title} />
                <input
                    placeholder="Description"
                    name="description"
                    defaultValue={category.description}
                />
                <button type="submit">Save</button>
            </form>

            <button className="warn" onClick={close}>
                Cancel
            </button>
        </>
    );
};

export default EditCategoryDialog;
